var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          staticClass: "navbar position-absolute",
          attrs: { toggleable: "lg" }
        },
        [
          _c("b-navbar-brand", { attrs: { href: "/" } }, [
            _c("img", {
              staticClass: "navbar-brand-img",
              style: _vm.getLogoStyles,
              attrs: { src: _vm.getLogo }
            })
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c("b-navbar-nav", { staticClass: "ml-auto" }, [
                _c(
                  "span",
                  { staticStyle: { display: "contents" } },
                  [
                    _c(
                      "b-nav-item",
                      [
                        _c(
                          "base-button",
                          {
                            attrs: { blue: "" },
                            on: {
                              click: function() {
                                _vm.$router.push("/inicio-sesion")
                              }
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.$t("login-wrd")))]),
                            _vm._v(" "),
                            _c("base-icon", {
                              staticClass: "ml-2",
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: _vm.$uiHelpers.isMobile
                                  ? _vm.ORANGE_COLOUR
                                  : "white"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("abogality-main-block"),
      _vm._v(" "),
      _c("abogality-cards-slider"),
      _vm._v(" "),
      _c("abogality-security-privacity-block"),
      _vm._v(" "),
      _c("abogality-professional-platform"),
      _vm._v(" "),
      _c("abogality-subscriptions"),
      _vm._v(" "),
      _c("companies-contact-form", {
        attrs: {
          subtitle: _vm.$t("abogalitypro.contact-form.text"),
          serviceType: _vm.$t("legal-services"),
          forIndividualsOnly: "",
          showReason: "",
          showCollegiateNumber: "",
          platform: "Openlegal",
          productName: "Openlegal"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7830d92c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7830d92c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/abogalitypro/Home.vue
// module id = 4145
// module chunks = 10